import React from 'react';
import LinkAsButton from 'ui/elements/buttons/LinkAsButton';

/**
 * Investor Matching constants
 */

export const INVESTOR_MATCHING_BASE_PRICE = '€500';

export const INVESTOR_MATCHING_PRICE_TEXT = `Prices from ${INVESTOR_MATCHING_BASE_PRICE} depending on stage, investor types, geographical spread and ticket sizes.`;

export const INVESTOR_MATCHING_BUTTON_STYLE = { minWidth: '130px' };

export const InvestorMatchingButton = () => (
  <LinkAsButton style={INVESTOR_MATCHING_BUTTON_STYLE} kind="primary" url="/communities/investor-matching">
    I&apos;m interested
  </LinkAsButton>
);
